<template>
  <div class="lib__field">
    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'other-equipment-connection')" class="lib__tile" data-cy="hp-form-tile-other-equipment-connection">
        <div class="lib__tile__text">{{ $t('common.otherEquipmentConnection') }}</div>
      </router-link>
      <router-link :to="getUrl(lang, 'construction-connection')" class="lib__tile" data-cy="hp-form-tile-construction-connection">
        <div class="lib__tile__text">{{ $t('common.constructionConnection') }}</div>
      </router-link>
    </div>

    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'temporary-connection')" class="lib__tile" data-cy="hp-form-tile-temporary-connection">
        <div class="lib__tile__text">{{ $t('common.temporaryConnection') }}</div>
      </router-link>
      <router-link :to="getUrl(lang, 'synergrid-connection')" class="lib__tile" data-cy="hp-form-tile-synergrid-connection">
        <div class="lib__tile__text">{{ $t('common.synergridConnection') }}</div>
      </router-link>
    </div>

    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'e-mobility')" class="lib__tile" data-cy="hp-form-tilee-mobility">
        <div class="lib__tile__text">{{ $t('e-mobility.rechargeAtHome') }}</div>
      </router-link>
      <router-link :to="getUrl(lang, 'prosumer-bonus')" class="lib__tile" data-cy="hp-form-tile-prosumer-bonus">
        <div class="lib__tile__text">{{ $t('common.prosumerBonus') }}</div>
      </router-link>
    </div>

    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'smart-meter-connection')" class="lib__tile" data-cy="hp-form-tile-smart-meter-connection">
        <div class="lib__tile__text">{{ $t('common.smartMeterConnection') }}</div>
      </router-link>
    </div>

    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'work-file-tracking')" class="lib__tile" data-cy="hp-form-tile-work-file-tracking">
        <div class="lib__tile__text">{{ $t('common.workFileTracking') }}</div>
      </router-link>
    </div>
    <br>
    <h2>Formulaires en cours de migration</h2>
    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'landing-page-cmh')" class="lib__tile">
        <div class="lib__tile__text">{{ $t('common.landingPageCmhFromCmh') }}</div>
      </router-link>
      <router-link :to="getUrl(lang, 'landing-page-ores')" class="lib__tile">
        <div class="lib__tile__text">{{ $t('common.landingPageCmhFromOres') }}</div>
      </router-link>
    </div>
    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'new-connection-cmh')" class="lib__tile">
        <div class="lib__tile__text">{{ $t('common.newConnectionCmh') }}</div>
      </router-link>
    </div>

    <br>
    <h2>Formulaires migrés</h2>
    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'prosumer-declaration')" class="lib__tile" data-cy="hp-form-tile-prosumer-declaration">
        <div class="lib__tile__text">{{ $t('prosumerDeclaration.title') }}</div>
      </router-link>
      <router-link :to="getUrl(lang, 'charging-station-declaration')" class="lib__tile" data-cy="hp-form-tile-charging-station-declaration">
        <div class="lib__tile__text">{{ $t('chargingStationDeclaration.title') }}</div>
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { routes } from '@/router'
import { localize } from 'vee-validate'

@Component({
  name: 'home'
})
export default class Home extends Vue {
  //#region [Data]
  @Prop({ type: String, required: true }) public readonly lang!: string
  //#endregion

  //#region [Watch]
  @Watch('lang')
  public onLangChanged(value: string) {
    this.$i18n.locale = value
    localize(value)
    this.$store.commit('SET_LANGUAGE', value)
  }
  //#endregion

  //#region [Method]
  public getUrl(lang: string, form: string): string {
    return routes.find((r) => r.name === form)!.paths[lang]
  }
  //#endregion
}
</script>

<style>
@media screen and (max-width: 576px) {
  .lib__nav {
    background-color: #f9f8f8;
    margin: 0;
    max-width: 576px;
  }
  header.lib__form__header {
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
  }
  div.lib__form__main {
    padding-top: 20px;
  }
}
.lib__nav__step__dot {
  white-space: nowrap;
}
</style>
